/**
 * 客源渠道
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';

import ReserveChannelInfo from '@/components/Reservation/ChannelInfo';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { handleChannelDataChange } from '@/redux/actions/reservation/createReserve';
import { ReducerState, storeName } from '@/redux/reducers/reservation/createReserve';

import { getPopupContainer } from '../../helper';

const stateSelector = (state: ReducerState) => {
  const { channelList, strategyList, channelInfo } = state;
  return { channelList, strategyList, channelInfo };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  callChannelDataChange: handleChannelDataChange,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

const Index: React.FC<MapStateProps & MapDispatchProps> = (props) => {
  const { channelInfo, channelList, strategyList, callChannelDataChange } = props;

  return (
    <ReserveChannelInfo
      value={channelInfo}
      channelList={channelList}
      strategyList={strategyList}
      onChange={callChannelDataChange}
      getPopContainer={getPopupContainer}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
